module.exports = __webpack_public_path__ + "img/scale-add.dc40e39a.png";